import React, { useState } from 'react'
import connect from '../connect'
import { IconButton } from '@material-ui/core'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

import useBooleanHandlers from '../../../../../hooks/useBooleanHandlers'
import { useTrans } from '../../../../../services/i18n'
import AddNewFile from './AddNewFile'
import ConfirmDialog from '../../../../../components/generics/Confirm/Dialog'
import Typography from '../../../../../components/common/Typography'
import { useAlertContext } from '../../../../../contexts/AlertContext'
import { selectUserPermissions, isEnabled } from '../../../../../selectors'
import { useSelector } from 'react-redux'

const ItemMenu = ({
  cat,
  deleteRequestTemplateFile,
  requestTemplateId,
  getList,
}) => {
  const { trans } = useTrans()
  const permissions = useSelector(selectUserPermissions)
  const [open, openModal, onCloseModal] = useBooleanHandlers()
  const [openConfirmDelete, onOpenConfirmDelete, onCloseConfirmDelete] =
    useBooleanHandlers()
  const { successAlert, errorAlert } = useAlertContext()
  const [pendingDelete, setPendingDelete] = useState(false)

  const onDelete = async () => {
    setPendingDelete(true)
    const { payload } = await deleteRequestTemplateFile({
      id: cat.id,
      requestTemplateId,
    })
    successAlert(payload.message)
    setPendingDelete(false)
    onCloseConfirmDelete()
    getList({
      requestTemplateId: requestTemplateId,
      text: '',
      order: ['createdAt', 'desc'],
      filters: {},
      pagination: { page: 1, perPage: 10 },
    })
  }

  return (
    <>
      {isEnabled(permissions, 'request-templates', '', 'edit') && (
        <IconButton onClick={openModal}>
          <EditIcon />
        </IconButton>
      )}
      {isEnabled(permissions, 'request-templates', '', 'delete') && (
        <IconButton onClick={onOpenConfirmDelete}>
          <DeleteIcon />
        </IconButton>
      )}
      <AddNewFile
        requestTemplateId={requestTemplateId}
        item={{
          id: cat.id,
          filename: cat.name,
          description: cat.description,
          daysToFill: cat.daysToFill,
        }}
        open={open}
        onClose={onCloseModal}
      />
      <ConfirmDialog
        open={openConfirmDelete}
        onClose={onCloseConfirmDelete}
        onConfirm={onDelete}
        pending={pendingDelete}
        title={trans('remove-file-template')}
        text={`${trans('remove-file-template')} ?`}
        note={'It will no affect requests made from this template'}
      >
        <Typography color="hint">{trans('file-name')}</Typography>
        <Typography color="hint" weight="bold">
          {cat.name}
        </Typography>
      </ConfirmDialog>
    </>
  )
}

export default connect(ItemMenu)
